module.exports = __webpack_public_path__ + "static/media/pexels-jean-van-der-meulen-1457842.6c1ba6cb.jpg";